import React, { useCallback } from 'react';

import { Control } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';

import { useUpdateField } from '../hooks';
import { useLicense } from '../LicenseProvider';

function EstimateBodyToggle() {
  const { isFeatureAvailable } = useLicense();
  const isBodyLicenseAvailable = isFeatureAvailable('estimations.body_attributes');
  const { control } = useFormContext();
  const estimateBody = useWatch({ name: 'estimate.body' });
  const onDisableEstimateBodyCallback = useCallback(() => estimateBody === false, [estimateBody]);

  useUpdateField({ path: 'estimate.face', value: true, on: onDisableEstimateBodyCallback });
  useUpdateField({ path: 'extract.bodyDescriptor', value: false, on: onDisableEstimateBodyCallback });

  return (
    <Control.Switch
      control={control}
      disabled={!isBodyLicenseAvailable}
      name="estimate.body"
    />
  );
}

export { EstimateBodyToggle };
